import React from 'react';
import './TextView.css';

const TextView = ({ text, onTextChange, isPanelVisible, isTransitioning }) => {
  return (
    <div
      className="textViewContainer"
      style={{
        width: "calc(-300px + 100%)",
        marginLeft: isPanelVisible ? "220px" : "0",
        transition: isTransitioning ? "margin-left 0.3s ease-in-out" : "none",
      }}
    >
      <div className="textCard">
        <textarea
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
          className="textViewTextarea"
          placeholder="ここに分析したい文章を入力してください..."
          style={{
            width: isPanelVisible ? "calc(100vw - 300px)" : "calc(100vw - 80px)",
            transition: isTransitioning ? "width 0.3s ease-in-out" : "none",
          }}
        />
      </div>
    </div>
  );
};

export default TextView;